<div class="bg-white p-2">
    <div class="row bg-white p-2">
        <div class="col-lg-2">
            <label class="control-label col-form-label">Stato</label>
            <ng-multiselect-dropdown [settings]="settingsDrop" [placeholder]="'Seleziona'" [data]="stato" [(ngModel)]="filtro.stato" (ngModelChange)="Refresh()">
            </ng-multiselect-dropdown>
        </div>
        <div>
            <label>Inizio</label>
            <input class="form-control" type="date" [(ngModel)]="filtro.inizio" (ngModelChange)="Refresh()">
        </div>
        <div class="ml-2">
            <label>Fine</label>
            <input class="form-control" type="date" [(ngModel)]="filtro.fine" (ngModelChange)="Refresh()">
        </div>
        <div class="col-lg-2">
            <label class="control-label col-form-label">Struttura</label>
            <ng-multiselect-dropdown [settings]="dropSetting" [placeholder]="'Seleziona'" [data]="strutture" [(ngModel)]="filtro.struttura">
            </ng-multiselect-dropdown>
        </div>
        <div class="col-lg-2">
            <label class="control-label col-form-label" *ngIf="ospiti">Ospite</label>
            <ng-multiselect-dropdown [settings]="dropSetting" [placeholder]="'Seleziona'" [data]="ospiti" [(ngModel)]="filtro.ospite" (ngModelChange)="Refresh()">
            </ng-multiselect-dropdown>
        </div>
    </div>
</div>
    <div class="bg-white mt-2 p-2" *ngIf="report">
        <!--<div class="col-lg-12">
            <label class="control-label col-form-label">Report: </label>
            <span> {{report?.statoObject?.label}}</span>
        </div>
        <div class="col-lg-12" *ngIf="filtro?.ospite">
            <label class="control-label col-form-label">Ospite: </label>
            <span> {{filtro?.ospite?.nominativo}}</span>
        </div>-->
        <div class="col-lg-12">
            <label class="control-label col-form-label">Data Ultimo Movimento: </label>
            <span> {{report?.dataFine | date: "dd/MM/yyyy"}}</span>
        </div>
        <!--<div class="col-lg-12">
            <label class="control-label col-form-label">Cassa: </label>
            <span> {{report?.cassa}}</span> 
        </div>-->
        <div>
            <table class="table table-hover bg-white">
                <tr>
                    <th>Data</th>
                    <th>+</th>
                    <th>-</th>
                    <th>Descrizione</th>
                </tr>
                <tr *ngFor="let fatture of report.fattureObject">
                    <td>{{fatture.data_prevista | date: "dd/MM/yyyy"}}</td>
                    <td>{{fatture.voci[0].prezzo}}</td>
                    <td>{{fatture.voci[1].prezzo}}</td>
                    <td>{{fatture.voci[0].voce}}</td>
                </tr>
                <tr>
                    <td><strong>Saldo</strong></td>
                    <td colspan="3">{{report.saldo}}</td>
                </tr>
            </table>
        </div>
</div>
